<template lang="pug">
  el-dialog(
    v-bind:visible="visible"
    @update:visible="$emit('update:visible', this)"
    ref='dialog'
  )
    //el-carousel( height="400px" autoplay='false' )
      //el-carousel-item( v-for='photo in listing.Photos' :key='photo') 
        img( v-bind:src="photo")
    div(id='outerDiv')
      swiper( :options="swiperOptions" class='swiper-container' style="height: auto" ref='swiper' :activeIndex='photoIndex')
        swiper-slide( v-for='photo in listing.Photos' :key='photo')
          img( v-bind:src="photo")
        div( class="swiper-pagination"  slot="pagination")
        div( class="swiper-button-prev" slot="button-prev") &#9664;
        div( class="swiper-button-next" slot="button-next") &#9654;
        // div( class="swiper-scrollbar"   slot="scrollbar")
      div(id='description-div')
        div(class='description-header')
          h2 {{listing.StreetNumber}} {{listing.StreetName.replace(/\.$/, "")}}, {{listing.City}} {{listing.Neighborhood ? "(" + listing.Neighborhood + ")" : ""}}
          //ul
            li {{bedBathString}}
            li(v-if="listing.RentIncludes" class="unitIncludes") Rent includes: {{listing.RentIncludes.RentInclude.toString()}}
            li {{feeString}}
            li {{availableString}}
          div( class="focus-button" @click="viewingRequested") Contact Us &#x25b7;
        el-button( type="text" icon="el-icon-arrow-left" @click='loadPrevListing' :class='{hidden: !prevListing}') Previous Listing
        el-button( type="text" :icon="(isInFavorites ? 'el-icon-star-on' : 'el-icon-star-off')" @click="toggleInFavorites") Favorite
        //el-button( type="text" icon="el-icon-date" @click="viewingRequested") Contact Agent
        el-button( type="text" @click='loadNextListing'  :class='{hidden: !nextListing}') Next Listing <i class="el-icon-arrow-right"/>
        //fas fa-bed, fa fa-bath, fas fa-dollar-sign
        div( class="bed_bath_div" )
          span #[i(class='fas fa-bed')] {{bedString}}
          span #[i(class='fas fa-bath')] {{bathString}}
          span #[i(class='fas fa-dollar-sign')] {{listing.Price}}/mo

          //i(class='fas fa-bed')
          //i(class='fas fa-bath')
          //i(class='fas fa-dollar-sign')
        table
          //tr
            th Rooms
            td {{bedBathString}}
          tr(v-if="listing.SquareFootage")
            th Square Footage
            td {{listing.SquareFootage}}
          tr
            th Available
            td {{availableString}}
          //tr
            th Rent
            td ${{listing.Price}}/mo
          tr(v-if="listing.RentIncludes")
            th Rent Includes
            td {{listing.RentIncludes.RentInclude.toString()}}
          tr
            th Real Estate Fee
            td {{feeString}}
          tr
            th Listing ID
            td {{listing.ID}}
          tr(v-if="listing.Laundry && listing.Laundry != 'Unknown'")
            th Laundry
            td {{listing.Laundry}}
          tr(v-if="parkingString.length > 0")
            th Parking
            td {{parkingString}}
          tr(v-if="listing.Pet")
            th Pets
            td {{listing.Pet}}
          tr(v-if="listing.Student")
            th Students
            td {{listing.Student}}
          tr(v-if="listing.BuildingType")
            th Building Type
            td {{listing.BuildingType}}
          tr(v-if="listing.UnitLevel")
            th Unit Level
            td {{listing.UnitLevel}}
          //Pet Student BuildingType UnitLevel SquareFootage Laundry Parking
        p {{listing.UnitDescription}}
        ul(v-if='listing.Features' class='feature-list')
          li(v-for='feature in listing.Features.Feature' v-if='feature.length > 1') {{feature}}
      //ul(v-if='listing.POI')
        li(v-for='point in listing.POI.Point') {{point}}
      //el-button-group
      
      //el-button(type="warning" :icon="el-icon-date" @click="viewingRequested" ) Request Viewing
    iframe( frameborder="0" allowfullscreen :src="mapURL" ) Your browser does not support this map.
    el-button( type="text" icon="el-icon-arrow-left" @click='loadPrevListing' v-if='prevListing') Previous Listing
    el-button( type="text" :icon="(isInFavorites ? 'el-icon-star-on' : 'el-icon-star-off')" @click="toggleInFavorites") Favorite
    el-button( type="text" icon="el-icon-date" @click="viewingRequested") Contact Agent
    el-button( type="text" @click='loadNextListing'  :class='{hidden: !nextListing}') Next Listing <i class="el-icon-arrow-right"/>
</template>

<script>
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { GOOGLE_MAPS_URL } from './settings'
  //import { mapGetters } from 'vuex'
  export default {
    components: {
      swiper,
      swiperSlide
    },
    props: {
      listing: Object,
      visible: Boolean,
      listingArray: Array,
    },
    data(){
      return{
        //visible: this.isVisible,
        timeout: null,
        photoIndex: 0,
        swiperOptions: {
          autoHeight: true, //enable auto height
          spaceBetween: 20,
          observer: true,
          observeSlideChildren: true, //Do I need?
          grabCursor: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          keyboard: {
            enabled: true,
          }
        }
      }
    },
    computed: {
      swiper(){
        return this.$refs.swiper.swiper;
      },
      address(){
        return this.listing
          ? [
              this.listing.StreetNumber, this.listing.StreetName//, 
              //this.listing.Unit ? "#"+ this.listing.Unit : ""
            ].join(" ")
          : "";
      },
      mapURL() {
        return GOOGLE_MAPS_URL + "&q=" + 
          //[this.listing.StreetName, this.listing.City, "MA"].join("+");
          [this.listing.StreetNumber, this.listing.StreetName, this.listing.City, "MA"].join("+");
      },
      isInFavorites(){
        return this.$store.getters.listingIsInFavoriteListings(this.listing);
      },
      feeString(){
        switch (this.listing.Fee){
          case "1":     return "No Fee";
          case "0":     return "Full Fee";
          case "0.5":   return "Half Fee";
          case "0.75":  return "Tenants pay 25% of the fee";
          case "0.25":  return "Tenants pay 75% of the fee";
          default:      return "Fee: " + this.listing.Fee;
        }
      },
      bedString(){
        let numBeds = parseInt(this.listing.Beds);
        if ( this.listing.Beds > numBeds){
          return numBeds + "|" + (numBeds + 1) + " Bed Split";
        }
        else if (numBeds == 0 || this.listing.Beds.toLowerCase() === "studio"){
          return "Studio";
        }
        else{
          return numBeds + ((numBeds > 1) ? " Beds" : " Bed");
        }  
      },
      bathString(){
        let baths = this.listing.Baths;
        return baths == 0
          ? ""
          : parseFloat(baths) + " Bath" + (baths > 1 ? "s" : "")
      },
      bedBathString(){
        let bathString = this.bathString;
        return this.bedString + (bathString.length > 0 ? ", " + bathString : "");
      },
      availableString(){
        let availDate = (this.listing.AvailableDate ? new Date(this.listing.AvailableDate) : new Date());
        return (availDate > new Date())
          ? availDate.toLocaleDateString('us-EN', {month:'long', day:'numeric', year: 'numeric'})
          : "Available Now";
      },
      parkingString(){
        let availability = this.listing.Parking && this.listing.Parking.ParkingAvailability ? this.listing.Parking.ParkingAvailability : null;
        let type = this.listing.Parking && this.listing.Parking.ParkingType ? this.listing.Parking.ParkingType : null;
        if (availability){
          if (availability == "STR")
            return "Street Parking" + (type ? ", " + type : "");
          else if (availability == "FOR")
            return "Parking for Rent" + (type ? ", " + type : "");
          else if (availability == "INC")
            return "Included" + (type ? ", " + type : "");
          else
            return availability + (type ? ", " + type : "");
        }
        else return "";
      },
      prevListing(){
        return this.listingArray && this.listingArray.indexOf(this.listing) > 0
            ? this.listingArray[this.listingArray.indexOf(this.listing)-1]
            : null;
      },
      nextListing(){
        return this.listingArray && this.listingArray.indexOf(this.listing) < this.listingArray.length - 1
            ? this.listingArray[this.listingArray.indexOf(this.listing)+1]
            : null;
      }
      //{ "ParkingAvailability": "STR" } { "ParkingAvailability": "STR", "ParkingType": "Permit" } { "ParkingAvailability": "FOR" } { "ParkingAvailability": "FOR", "ParkingType": "Garage" } { "ParkingAvailability": "FOR", "ParkingType": "Outdoor" }
      // photosExist(){
      //   return this.listing && this.listing.Photos;
      // },
      // photos(){
      //   return (typeof this.listing.Photos === "string") 
      //           ? [this.listing.Photos.Photo] 
      //           : this.listing.Photos.Photo;
      // }
    },
    methods: {
      resetSwiper(){
        this.swiper.updateAutoHeight(0);
        this.swiper.slideTo(0, 0);
      },
      
      loadPrevListing(){
        if (this.prevListing) this.$emit('update:active-listing', {listing:this.prevListing, listings:this.listingArray});
        this.resetSwiper();
        this.$refs.dialog.scrollTop = 0; //doesn't work, I think?
      },
      loadNextListing(){
        if (this.nextListing) this.$emit('update:active-listing', {listing:this.nextListing, listings:this.listingArray});
        this.resetSwiper();
        this.$refs.dialog.scrollTop = 0;
      },
      viewingRequested(){
        this.addInFavorites();
        this.$emit('update:visible', false);
        this.$router.push("/contact");
      },
      
      toggleInFavorites(){
        this.isInFavorites
          ? this.removeInFavorites()
          : this.addInFavorites()
      },

      addInFavorites(){
        if( this.$store.getters.listingIsFavoriteListingsFull ){
          this.$notify.warning({ title:"Favorites Full", message: "Your favorites list is full.", position:"bottom-right", offset: 100})
        }
        else{
          this.$store.commit('listingAddFavorite', this.listing);
          this.$notify.success({ title:this.address, message: "Unit added to your favorites.  Use the star icon below to see them!", position:"bottom-right", offset: 100})
        }
      },

      removeInFavorites(){
        this.$store.commit('listingRemoveFavorite', this.listing);
        this.$notify.info({ title:this.address, message: "Unit removed from your favorites.", position:"bottom-right", offset: 100})
      }
    },
    mounted: function(){
      if (!this.timeout){
        this.timeout = setInterval(() => {
          this.swiper.updateAutoHeight(200);
        }, 200);
      }
    },
    beforeDestroy: function(){
      clearTimeout(this.timeout);
    }
  }
</script>

<style scoped lang="scss">
//@import '../_variables';

iframe{
  width: 100%;
  height: 400px;
  // border-top: 3px solid $color-primary;
  // border-bottom: 3px solid $color-primary;
  // box-shadow: 2px 2px 3px $color-primary;
}
.swiper-container{
  // border-bottom: 3px solid $color-primary;
  // border-top: 3px solid $color-primary;
  //background-color: mix(white, $color-primary, 90);
  padding: 0;
  //margin-top: -20px;
  max-width: 710px;
  // box-shadow: 2px 2px 3px $color-primary;
}

img{
  width: 100%;
  max-width: 710px;
  max-height: 90vh;
  object-fit: cover;
}
.swiper-button-prev, .swiper-button-next {
  background-image: none;
  font-size: 3em;
  color:  white;
  text-shadow: 1px 1px 3px $color-primary;
}

#description-div{
  position: relative;
  flex: 1 1 450px;
}

button{
  //position: absolute;
  right: 3px;
  top: 5px;
}

h2{
  //background: linear-gradient(mix(black, $color-primary, 40), mix(black, $color-primary, 60));
  //color: white;
  padding: 10px 10px 5px 10px;
  border-radius: 0px;
  margin: 0;
  //margin-top: -5px;
  background: transparent;
  padding-left: 0;
  //color: mix(black, $color-primary, 20);
  text-align: center;
  font-weight: 100;
  font-size: 1.7em;
  //background: mix(black, $color-primary, 40);
  color: white;
  word-break: normal;
  //box-shadow: 0 1px 2px black;
  //border-top: 3px solid $color-accent;
}

.description-header{
  background-image: radial-gradient(circle, #303e6a, #181f35);
  padding-bottom: 9px;
  position: sticky;
  top: 0;
}

.focus-button{
  cursor: pointer;
  font-size: 1.5em;
  padding: 6px;
  
  color: white;
  background-color: $color-accent;
  margin: 0 20px 0 20px;
  border-radius: 2px;
  text-shadow: 1px 1px 2px rgb(99, 99, 99);
  transition: all .2s ease-in-out;
}

.focus-button:hover{
  //background-color: orange;
  transform: scale(.95);
  //background-color: mix(white, $color-accent, 20);
}

.swiper-button-disabled{
  display: none;
}

.swiper-pagination-bullet-active{
  background: $color-accent;
  border: 1px solid $color-primary;
}

.swiper-button-prev, .swiper-button-next{
  height: 100%;
  top: 0;
  margin: auto;
  padding-top: 30%;
}

.feature-list{
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  justify-content: center;
}

.feature-list li{
  padding: 3px;
  padding-left:  6px;
  padding-right: 6px;
  margin: 4px;
  background-color: mix(black, $color-primary, 30);
  color: white;
  //border-right: 2px solid $color-primary;
  //border-left: 2px solid $color-primary;
  border-radius: 2px;

}

table{
  width: 100%;
  //max-width: 400px;
  margin: 0;
  font-size: 1.4em;
}

td{
  text-align: right;
  color: mix(black, $color-primary, 30);
  //background: mix(white, $color-primary, 90);
  padding: 4px;
}

th{
  text-align: left;
  font-weight: 100;
  height: 30px;
  //background: mix(white, $color-accent, 90);
  padding: 4px 0;
}

p{
  font-size: 1.2em;
  word-break: normal;
}

#outerDiv{
  display: flex;
  flex-wrap: wrap;
}

.hidden{
  visibility: hidden;
}

.bed_bath_div{
  display: flex;
  font-size: 1.8em;
  color: $color-primary;
  justify-content: space-between;
  padding: 10px;
}

@media screen and (max-width: 660px) {
  
}

@media screen and (min-width: 1350px){
  // #description-div{
  //   border-left: 3px solid mix(black, $color-primary, 40);
  // }
  // iframe{
  //   border-top: 6px solid $color-primary;
  // }
}

.swiper-pagination-bullet-active{
  background: $color-accent;
  border: 1px solid $color-primary;
}

.bed_bath_div, table{
  padding: 20px 0;
}

</style>

<style lang="scss">
#app .el-dialog{
  width: 90%;
  max-width: 750px;
}


#app .el-dialog__header{
  padding: 2px;
}

@media screen and (max-width: 660px) {
  #app .el-dialog{
    width: 100%;
  }
}

//uncomment to open back up the side by side design
// @media screen and (min-width: 1350px){
//   #app .el-dialog{
//     max-width: 1400px;
//   }
//   // iframe{
//   //   border-top: 6px solid $color-primary;
//   // }
// }
</style>
